import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../../Contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { updateUser } from "../../../api/usersApi";
import './editP.css'
import swal from "sweetalert";
import { RiLockPasswordLine } from "react-icons/ri";
import { TbPasswordUser } from "react-icons/tb";
import { PiPassword } from "react-icons/pi";

export default function EditProfile() {
    const { user, setUser, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const id = user?.id;

    const [form, setForm] = useState({
        nom: "",
        email: "",
        role: "",
        current_password: "",
        password: "",
        password_confirmation: "" 
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (user) {
            setForm({
                nom: user.nom || "",
                email: user.email || "",
                role: user.role || "",
                current_password: "",
                password: "",
                password_confirmation: ""
            });
        }
    }, [user]);

    function handleChange(e) {
        setForm({ ...form, [e.target.name]: e.target.value });
        if (errors[e.target.name]) {
            setErrors({ ...errors, [e.target.name]: "" });
        }
    }

    function validateForm() {
        const newErrors = {};
        // 
        if (form.password || form.password_confirmation || form.current_password) {
            
            if (!form.current_password) {
                newErrors.current_password = "Le mot de passe actuel est requis";
            }

            if (!form.password) {
                newErrors.password = "Le nouveau mot de passe est requis";
            } else if (form.password.length < 8) {
                newErrors.password = "Le mot de passe doit contenir au moins 8 caractères";
            }


            if (!form.password_confirmation) {
                newErrors.password_confirmation = "Veuillez confirmer votre mot de passe";
            } else if (form.password !== form.password_confirmation) {
                newErrors.password_confirmation = "Les mots de passe ne correspondent pas";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    function handleSubmit(e) {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const payload = {
            nom: form.nom,
            email: form.email,
        };

        const passwordChanged = form.password.trim() !== "";

        if (passwordChanged) {
            payload.current_password = form.current_password;
            payload.password = form.password;
            payload.password_confirmation = form.password_confirmation;
        }

        updateUser(id, payload)
            .then((updatedUser) => {
                if (passwordChanged) {
                    swal(
                        "Mot de passe modifié", 
                        "Veuillez vous reconnecter avec votre nouveau mot de passe.", 
                        "success"
                    );
                    logout();
                    navigate("/");
                } else {
                    setUser(updatedUser);
                    swal("Profil mis à jour avec succès", "", "success");
                    navigate("/eleveur/profile");
                }
            })
            .catch((error) => {
                const errorMsg = error.response?.data?.message || "Erreur de saisie";
                swal("Erreur", errorMsg, "error");
            });
    }

    if (!user) {
        return <div>Loading or access denied...</div>;
    }

    return (
        <div className="user-form-container">
            <div className="user-form-card">
                <h2>Modifier Votre Mot de passe</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Mot de passe actuel <span style={{color: 'red'}}>*</span><RiLockPasswordLine className="pass"/></label>
                            <input
                                type="password"
                                name="current_password"
                                value={form.current_password}
                                onChange={handleChange}
                                className={errors.current_password ? 'error' : ''}
                            />
                            {errors.current_password && (
                                <span className="error-text">{errors.current_password}</span>
                            )}
                        </div>

                        <div className="form-group">
                            <label>Nouveau mot de passe <span style={{color: 'red'}}>*</span><TbPasswordUser className="pass"/></label>
                            <input
                                type="password"
                                name="password"
                                value={form.password}
                                onChange={handleChange}
                                className={errors.password ? 'error' : ''}
                                minLength={8}
                            />
                            {errors.password && (
                                <span className="error-text">{errors.password}</span>
                            )}
                            <small style={{color: '#666', fontSize: '0.85rem'}}>
                                Minimum 8 caractères
                            </small>
                        </div>

                        <div className="form-group">
                            <label>Confirmer le nouveau mot de passe <span style={{color: 'red'}}>*</span><PiPassword className="pass"/></label>
                            <input
                                type="password"
                                name="password_confirmation"
                                value={form.password_confirmation}
                                onChange={handleChange}
                                className={errors.password_confirmation ? 'error' : ''}
                                minLength={8}
                            />
                            {errors.password_confirmation && (
                                <span className="error-text">{errors.password_confirmation}</span>
                            )}
                        </div>
                    </div>

                    <button type="submit" className="submit-btn">
                        Enregistrer
                    </button>
                </form>
            </div>
        </div>
    );
}